import { createStore } from 'vuex'
import axios from 'axios'
import api from '@/api'
import router from '@/router'
import createPersistedState from 'vuex-persistedstate'
import successIcon from '@/assets/image/success_icon.png'
const Swal = require('sweetalert2')
const debug = process.env.NODE_ENV !== 'production'

export default createStore({
  state: {
    errorMessage: null,
    lang: 'zh',
    auth: {
      authorized: false,
      user: null,
      userRole: null, // 'prime_english
      group: null
    },
    isLoading: false,
    nodeEnv: process.env.NODE_ENV,
    auth_email: null,
    remainPoints: 0,
    playbackRate: 1,
    isOpenSubtitle: true,
    level: null,
    ai_sid: null,
    ai_uuid: null,
    selectedAccent: 'en-EN' // 'en-EN ', 'it-IT', 'en-GB', 'en-AU'
  },

  getters: {
    authorized:  (state) => state.auth.authorized,
    userRole:  (state) => state.auth.userRole,
    user:  (state) => state.auth.user,
    isLoading:  (state) => state.isLoading,
    lang:  (state) => state.lang,
    remainPoints:  (state) => state.remainPoints,
    isOpenSubtitle:  (state) => state.isOpenSubtitle,
    playbackRate:  (state) => state.playbackRate,
    selectedAccent: state => state.selectedAccent,
    level: state => state.level,
    ai_sid: state => state.ai_sid,
    ai_uuid: state => state.ai_uuid,
    group: state => state.auth.group
  },

  actions: {
    async useTokenLogin({ commit, dispatch }, token) {
      try {
        dispatch('isLoading', true)

        await commit('LOGIN' , '')
        // await localStorage.removeItem('prime_english')
        await localStorage.setItem('authorizedAIToken', token)
        dispatch('getProfile')
        dispatch('getRemainPoints')
        dispatch('isLoading', false)
      } catch (err) {
        dispatch('isLoading', false)
        console.error(err)
        Swal.fire({
          html: `<p class="mb-2 whitespace-pre-wrap text-center ">錯誤</p>`,
          showDenyButton: false,
          focusConfirm: false,
          confirmButtonText: '關閉',
          title: '提示',
          customClass: {
            popup: 'p-0 max-w-md w-full',
            header: 'swal-header-notice justify-center items-center',
            htmlContainer: 'my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit ai_bg_01 rounded',
            title: 'text-white text-lg py-4 ai_bg_01'
          }
        })
      }
    },

    async loginWebsite({ commit, dispatch }, user) {
      try {
        dispatch('isLoading', true)
        const path = user.routeName === 'login_prime_english'
          ? 'https://cloud.liveabc.com/api/tp/chenliedu/login'
          : 'https://cloud.liveabc.com/api/tp/LiveABC/login'
        const response = await axios.post(path, {
          email: user.email,
          password: user.password
        })

        if (response) {
          commit('LOGIN')
          // if (user.routeName === 'login_prime_english') {
          //   commit('LOGIN' , 'prime_english')
          //   localStorage.setItem('prime_english', true)
          // } else {
          //   commit('LOGIN' , '')
          //   localStorage.removeItem('prime_english')
          // }

          localStorage.setItem('authorizedAIToken', response.data.access_token)

          // dispatch('getProfile')
          dispatch('getRemainPoints')
          router.push({ name: 'myList' })
          dispatch('isLoading', false)
        }
      } catch (err) {
        dispatch('isLoading', false)
        console.error(err)
        Swal.fire({
          html: `<p class="mb-2 whitespace-pre-wrap text-center ">${err.response.data.msg}</p>`,
          showDenyButton: false,
          focusConfirm: false,
          confirmButtonText: '關閉',
          title: '提示',
          customClass: {
            popup: 'p-0 max-w-md w-full',
            header: 'swal-header-notice justify-center items-center',
            htmlContainer: 'my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit ai_bg_01 rounded',
            title: 'text-white text-lg py-4 ai_bg_01'
          }
        })
      }
    },

    login_func: async ({ commit, dispatch }, token) => {
      await axios.post(`https://cloud.liveabc.com/api/tp/LiveABC/login`, {
          token: token.token
        })
      .then(response => {
        commit('LOGIN', 'user')
        dispatch('getProfile')
        dispatch('getRemainPoints')
        router.push({ name: 'myList' })
        localStorage.setItem('authorizedAIToken', response.data.access_token)
      })
      .catch(error => {
        console.log(error)
      })
    },

    async loginByGoogle ({ dispatch }, token) {
      try {
        // const path = 'https://cloud.liveabc.com/api/login/google'
        const path = 'https://api.liveabc.com/v1/google_login'
        const response = await axios.post(path, {
          token: token
        })

        if (response) {
          dispatch('login_func', { token: response.data.access_token })
        }
      } catch (err) {
        const errorData = (err.response && err.response.data) || {}
        const errText = errorData.msg || errorData.error || '錯誤'
        const isGoogleUserNotFound = /user not found/i.test(errText)
        const message = isGoogleUserNotFound
          ? '使用Google帳號建立LiveABC會員，設定完成後即可使用Google帳號快速登入！！'
          : errText

        Swal.fire({
          html: `<p class="mb-2 whitespace-pre-wrap text-center ">${message}</p>`,
          showDenyButton: false,
          focusConfirm: false,
          confirmButtonText: '確認',
          title: '提示',
          customClass: {
            popup: 'p-0 max-w-md w-full',
            header: 'swal-header-notice justify-center items-center',
            htmlContainer: 'my-4',
            actions: 'mb-4 mt-2',
            confirmButton: 'btn-submit ai_bg_01 rounded',
            title: 'text-white text-lg py-4 ai_bg_01'
          }
        }).then((result) => {
          if (result.isConfirmed && isGoogleUserNotFound && errorData.data) {
            router.push({ name: 'register', query: errorData.data })
          }
        })
      }
    },

    async getProfile ({ commit, dispatch }) {
      let path = `/users/me`
      try {
        let response = await api.get(path)
        if (response && response.error) {
          dispatch('logout')
        } else {
          commit('UPDATEPROFILE', response.data)
          dispatch('getGroup')
          if (response.data.groups.length > 0) {
            // for (variable of response.data.groups) {
            //   dispatch('getGroupsMembers', variable)
            // }
          }
        }
      } catch (err) {
        console.error(err);
      }
    },

    async getRemainPoints({ commit }) {
      let path = `https://cloud.liveabc.com/api/tp/LiveABC/points`
      try {
        let response = await api.get(path)
        if (response && response.data) {
          commit('SETUSER', response.data)

        }
      } catch (err) {
        console.error(err);
      }
    },

    async logout({ commit, state }) {
      if (state.auth.user.origin === 'chenliedu') {
        router.push({ name: 'login_prime_english' })
      } else {
        router.push({ name: 'login' })
      }
      localStorage.removeItem('authorizedAIToken')
      commit('LOGOUT')
    },

    async setPlayBackRate({ commit }, data) {
      commit('SETPLAYBACKRATE', data)
    },
    async toggleSubtitle({ commit }, data) {
      commit('TOGGLESUBTITLE', data)
    },
    async setLevel({ commit }, data) {
      commit('SETLEVEL', data)
    },
    swal(context, options) {
      void context
      return Swal.fire(options)
    },
    async isLoading({ commit }, data) {
      commit('ISLOADING', data)
    },
    async register({ dispatch }, user) {
      try {
        await axios.post('https://api.liveabc.com/v1/register?proof=1', {
          name: user.name,
          password: user.password,
          account: user.account,
          code: user.code,
          isAgreeReceiveDM: user.isAgreeReceiveDM
        });

        await dispatch('loginWebsite', { email: user.account, password: user.password })
        router.push({ name: 'myList' });
      } catch (error) {
        // dispatch('updateAlert', { isAlert: true, isHead: true, alertMsg: '驗證碼錯誤或帳號已存在', type: 'alert' })
      }
    },
    setAccent: ({ commit }, data) => {
      commit('SETACCENT', data)
    },

    // groups
    async getGroup({ commit }) {
      let path = `https://cloud.liveabc.com/api/groups`
      try {
        let response = await api.get(path)
        if (response && response.data) {
          commit('SETGROUP', response.data)
        }
      } catch (err) {
        console.error(err);
      }
    },

    async postGroup({ dispatch }, text) {
      let path = `https://cloud.liveabc.com/api/groups`
      try {
        let response = await api.post(path, {
          name: text
        })
        if (response && response.data) {
          Swal.fire({
            title: "Good job!",
            text: "已成功建立班級",
            icon: "success",
            customClass: {
              confirmButton: 'ai_bg_01'
            }
          })
          console.log(response.data)
          dispatch('getGroup')
        }
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
          customClass: {
            confirmButton: 'ai_bg_01'
          }
        })
      }
    },

    async getRegenerate_key({ dispatch }, id) {
      let path = `https://cloud.liveabc.com/api/groups/${id}/regenerate_key`
      try {
        let response = await api.post(path)
        if (response && response.data) {
          dispatch('getGroup')
        }
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
          customClass: {
            confirmButton: 'ai_bg_01'
          }
        })
      }
    },

    async deleteGroup({ dispatch }, id) {
      let path = `/groups/${id}/leave`
      try {
        let response = await api.delete(path)
        if (response && response.data) {
          Swal.fire({
            title: "Good job!",
            text: "已成功刪除班級",
            icon: "success",
            customClass: {
              confirmButton: 'ai_bg_01'
            }
          })
          dispatch('getGroup')
        }
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
          customClass: {
            confirmButton: 'ai_bg_01'
          }
        })
      }
    },
    async postGroup2({ dispatch }, id) {
      let path = `https://cloud.liveabc.com/api/groups/${id}/regenerate_key`
      try {
        let response = await api.post(path)
        if (response && response.data) {
          Swal.fire({
            title: "Good job!",
            text: "已成功建立班級",
            icon: "success",
            customClass: {
              confirmButton: 'ai_bg_01'
            }
          })
          dispatch('getGroup')
        }
      } catch (err) {
        Swal.fire({
          title: "Error",
          text: err.response.data.error,
          icon: "error",
          customClass: {
            confirmButton: 'ai_bg_01'
          }
        })
      }
    },
    async postOriginKey({ dispatch }, keyId) {
      let path = `/origin-keys/redeem`
      try {
        let response = await api.post(path, {
          key: keyId
        })
        if (response && response.data) {
          Swal.fire({
            html: `
              <div class="justify-center items-center flex flex-col py-4 ai_bg_03 text-white">
                <h2 class="text-lg font-bold">加入成功</h2>
              </div>
              <div class="justify-center items-center flex flex-col py-4">
                <img src="${successIcon}" alt="Success" class="mb-2" />
              </div>
              <div class="my-4 mb-8 font-bold text-center text-xl">歡迎加入</div>
            `,
            showConfirmButton: false,
            customClass: {
              popup: 'p-0 max-w-2xl w-full',
              header: 'ai_bg_03 swal-header-notice justify-center items-center',
              htmlContainer: 'm-0 p-0 font-bold',
              actions: 'mb-4 mt-2',
              confirmButton: 'btn-submit ai_bg_03 rounded',
              cancelButton: 'btn-submit bg-gray-400 rounded',
              title: 'text-white text-lg py-4 ai_bg_03'
            }
          })
          dispatch('getGroup')
          dispatch('getProfile')
          dispatch('getRemainPoints')
          router.push({ name: 'class_management' })
        }
      } catch (err) {
        console.error(err);
      }
    }
  },

  mutations: {
    ISLOADING (state, data) {
      state.isLoading = data
    },
    SETLANG (state, value) {
      state.lang = value
    },
    LOGIN (state) {
      state.auth.authorized = true
      // state.auth.userRole = data
    },
    SETUSER (state, data) {
      state.remainPoints = data.points
      state.auth.user = {
        ...(state.auth.user || {}),
        ...data
      }
    },
    LOGOUT (state) {
      state.auth.authorized = false
      state.auth.userRole = null
      state.remainPoints = 0
      state.auth.user = null
      state.auth.group = null
    },
    SETPLAYBACKRATE (state, value) {
      state.playbackRate = value
    },
    TOGGLESUBTITLE (state, value) {
      state.isOpenSubtitle = value
    },
    SETLEVEL (state, value) {
      state.level = value
    },
    SETACCENT (state, value) {
      state.selectedAccent = value
    },
    SETGROUP (state, value) {
      state.auth.group = value
    },
    UPDATEPROFILE (state, data) {
      state.auth.userRole = data.role
      state.auth.user = {
        ...(state.auth.user || {}),
        ...data
      }
    }
  },

  strict: debug,
  plugins: [createPersistedState({ paths: ['auth'] })]
})
